const seedrandom = require('seedrandom');

module.exports = {
  boardLayout () {
    return [
      ['WW', '2S', '3S', '4S', '5S', '6S', '7S', '8S', '9S', 'WW'],
      ['6C', '5C', '4C', '3C', '2C', 'AH', 'KH', 'QH', 'TH', 'TS'],
      ['7C', 'AS', '2D', '3D', '4D', '5D', '6D', '7D', '9H', 'QS'],
      ['8C', 'KS', '6C', '5C', '4C', '3C', '2C', '8D', '8H', 'KS'],
      ['9C', 'QS', '7C', '6H', '5H', '4H', 'AH', '9D', '7H', 'AS'],
      ['TC', 'TS', '8C', '7H', '2H', '3H', 'KH', 'TD', '6H', '2D'],
      ['QC', '9S', '9C', '8H', '9H', 'TH', 'QH', 'QD', '5H', '3D'],
      ['KC', '8S', 'TC', 'QC', 'KC', 'AC', 'AD', 'KD', '4H', '4D'],
      ['AC', '7S', '6S', '5S', '4S', '3S', '2S', '2H', '3H', '5D'],
      ['WW', 'AD', 'KD', 'QD', 'TD', '9D', '8D', '7D', '6D', 'WW']
    ];
  },

  cardAtBoardTile (tile) {
    const board = this.boardLayout();
    let row = parseInt(tile / 10);
    let col = tile % 10;
    return board[row][col];
  },

  boardTilesForCard (card) {
    const board = this.boardLayout();
    let tiles = [];
    for (let row = 0; row < 10; row++) {
      for (let col = 0; col < 10; col++) {
        if (board[row][col] == card) { tiles.push((row * 10) + col); }
      }
    }
    return tiles;
  },

  handFromString (handString) { return handString.match(/.{2}/g); },

  isCardDead (card, tileClaims) {
    const tiles = this.boardTilesForCard(card);
    if (tiles.length !== 2) { return false; }
    for (let i = 0; i < 2; i++) {
      let color = tileClaims.charAt(tiles[i]);
      if (color === '_') { return false; }
    }
    return true;
  },

  // Takes an object like { '*': [], o: [], r: [], g: [], b: [] } where each array is a list of player ids
  // Then validates that these players can be appropriately placed onto teams. '*' is random, 'o' is observer.
  setupPlayersOnTeams (teams) {
    if (!('*' in teams)) { teams['*'] = []; }
    if (!('o' in teams)) { teams['o'] = []; }
    if (!('b' in teams)) { teams['b'] = []; }
    if (!('g' in teams)) { teams['g'] = []; }
    if (!('r' in teams)) { teams['r'] = []; }

    let totalPlayers = teams['*'].length + teams.r.length + teams.g.length + teams.b.length;
    if (totalPlayers < 2 || totalPlayers > 12 || ((totalPlayers % 2 !== 0) && (totalPlayers % 3) !== 0)) {
      return 'cannot play with ' + totalPlayers + ' player' + (totalPlayers === 1 ? '' : 's');
    }

    // See how many teams were created by the admins
    let validTeams = [], totalTeams = 0;
    if (teams.b.length > 0) { totalTeams++; validTeams.push('b'); }
    if (teams.g.length > 0) { totalTeams++; validTeams.push('g'); }
    if (teams.r.length > 0) { totalTeams++; validTeams.push('r'); }

    // If any players were random, the number of teams is determined by total number of players, or at random
    if (teams['*'].length > 0 && totalTeams < 3) {
      if (totalPlayers % 3 !== 0) { totalTeams = 2; }
      else if (totalPlayers % 2 !== 0) { totalTeams = 3; }
      else { totalTeams = Math.random() > 0.5 ? 3 : 2; }
    }

    // Pick which teams will be valid and playable for this game...
    if (totalTeams === 3) { validTeams = ['b', 'g', 'r']; }

    // If only two teams, and blue is selected, randomize red or green. Otherwise, use red and green.
    else if (validTeams.length !== 2) {
      if (validTeams.indexOf('r') >= 0) { validTeams.push(Math.random() > 0.5 ? 'b' : 'g'); }
      else { validTeams = ['b', 'g']; }
    }

    // Randomize all random players and then put onto teams...
    teams['*'] = this.shuffleArray(teams['*']);

    while (teams['*'].length) {
      let minTeam = validTeams[0];
      let minCount = teams[validTeams[0]].length;
      for (let j = 1; j < validTeams.length; j++) {
        if (teams[validTeams[j]].length < minCount) {
          minTeam = validTeams[j];
          minCount = teams[validTeams[j]].length;
        }
      }

      let player = teams['*'].shift();
      teams[minTeam].push(player);
    }

    if (totalTeams === 3) {
      if (teams.r.length !== teams.g.length || teams.g.length !== teams.b.length) {
        return 'unbalanced teams';
      }
    }
    else if (teams[validTeams[0]].length !== teams[validTeams[1]].length) {
      console.log(validTeams, teams);
      return 'unbalanced teams';
    }

    return teams;
  },

  positionPlayersFromTeams (teams) {
    var validTeams = [];
    if ('b' in teams && teams.b.length > 0) { validTeams.push('b'); }
    if ('g' in teams && teams.g.length > 0) { validTeams.push('g'); }
    if ('r' in teams && teams.r.length > 0) { validTeams.push('r'); }

    validTeams = this.shuffleArray(validTeams);
    for (let i = 0; i < validTeams.length; i++) {
      teams[validTeams[i]] = this.shuffleArray(teams[validTeams[i]]);
    }

    // All teams should be the same length, so we key off of the first team's length...
    var positionedPlayers = [];
    for (let i = 0; i < teams[validTeams[0]].length; i++) {
      for (let j = 0; j < validTeams.length; j++) {
        positionedPlayers.push(teams[validTeams[j]][i]);
      }
    }

    return [positionedPlayers, validTeams];
  },

  shuffleArray (list, seed=null) {
    var rng = seed ? seedrandom(seed) : Math.random;
    for (let i = list.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  },

  shuffledDeck (seed) {
    var deck = [
      'AS', 'KS', 'QS', 'JS', 'TS', '9S', '8S', '7S', '6S', '5S', '4S', '3S', '2S',
      'AH', 'KH', 'QH', 'JH', 'TH', '9H', '8H', '7H', '6H', '5H', '4H', '3H', '2H',
      'AD', 'KD', 'QD', 'JD', 'TD', '9D', '8D', '7D', '6D', '5D', '4D', '3D', '2D',
      'AC', 'KC', 'QC', 'JC', 'TC', '9C', '8C', '7C', '6C', '5C', '4C', '3C', '2C',
      'AS', 'KS', 'QS', 'JS', 'TS', '9S', '8S', '7S', '6S', '5S', '4S', '3S', '2S',
      'AH', 'KH', 'QH', 'JH', 'TH', '9H', '8H', '7H', '6H', '5H', '4H', '3H', '2H',
      'AD', 'KD', 'QD', 'JD', 'TD', '9D', '8D', '7D', '6D', '5D', '4D', '3D', '2D',
      'AC', 'KC', 'QC', 'JC', 'TC', '9C', '8C', '7C', '6C', '5C', '4C', '3C', '2C'
    ];

    return this.shuffleArray(deck, seed);
  },

  dealInitialHands (deckSeed, players) {
    const deck = this.shuffledDeck(deckSeed);
    let size = deck.length, card = '';

    let numCardsInHand = 3;
    if (players.length < 10) { numCardsInHand = 4; }
    if (players.length < 8) { numCardsInHand = 5; }
    if (players.length < 6) { numCardsInHand = 6; }
    if (players.length < 3) { numCardsInHand = 7; }

    let playerHands = {};
    for (let i = 0; i < numCardsInHand; i++) {
      for (let j = 0; j < players.length; j++) {
        [card, size] = this.dealNextCardFromDeck(deck, size);
        if (!(players[j] in playerHands)) { playerHands[players[j]] = []; }
        playerHands[players[j]].push(card);
      }
    }

    return [playerHands, size];
  },

  dealNextCard (deckSeed, size) {
    const deck = this.shuffledDeck(deckSeed);
    return this.dealNextCardFromDeck (deck, size);
  },

  dealNextCardFromDeck (deck, size) {
    return [deck[104 - size], size - 1];
  },

  finalSelectedChain (chainPending, chainSelected) {
    let chainFinal = [];
    for (let i = 0; i < chainPending.length; i++) {
      // Find five in a row that player selected in the pending chain. Reset the chain if there is a gap.
      if (chainSelected.indexOf(chainPending[i]) >= 0) { chainFinal.push(chainPending[i]); }
      else { chainFinal = []; }

      // As soon as five in a row located, we are done.
      if (chainFinal.length == 5) { break; }
    }

    return chainFinal.length == 5 ? chainFinal : [];
  }
};
